import {
  adsApi,
  GetFlightsInlineAdsRequest,
  GetFlightsInlineAdsResponse,
  ResponseEnum,
} from "@b2bportal/ads-api";
import { axiosInstance } from "@hopper-b2b/api";

export const getFlightsInlineAds = async (
  request: GetFlightsInlineAdsRequest
): Promise<GetFlightsInlineAdsResponse> => {
  const res = await adsApi(axiosInstance).apiV0AdsFlightsInlineAdsPost(request);
  if (res.data.Response === ResponseEnum.Failure) {
    throw new Error(res.data.errors.join(","));
  }
  return res.data.value;
};
